import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProductElement } from '../../../../services/backend.service';

@Component({
    selector: 'app-change-quantity',
    templateUrl: './change-quantity.component.html',
    styleUrls: ['./change-quantity.component.scss'],
    standalone: false,
})
export class ChangeQuantityComponent {
    data = inject<ProductElement>(MAT_DIALOG_DATA);

    dialogValue = 0;

    constructor() {
        const data = this.data;

        this.dialogValue = data.config.quantity || 0;
    }
}
